import React from 'react';
import { useLocation } from 'react-router-dom';
import SettingsNavList from './SettingsNavList';
var BASE_PATH = '/czna-authorities';
var IMPORT_PATH = "".concat(BASE_PATH, "/import");
var SETTINGS_PATH = "".concat(BASE_PATH, "/settings");
var RULES_PATH = "".concat(BASE_PATH, "/validation-rules");
var DERIVATION_PATH = "".concat(BASE_PATH, "/derivation-rules");
var SEMANTIC_CATALOG_PATH = "".concat(BASE_PATH, "/semantic-catalog");
var HELP_TEXTS_PATH = "".concat(BASE_PATH, "/help-texts");
var VOCABULARY_TYPES_PATH = "".concat(BASE_PATH, "/vocabulary-types");
var OAI_HARVEST_PATH = "".concat(BASE_PATH, "/oai-harvest");
/** Settings sub-routes — being on one of these shows the settings sub-navigation. */
var SETTINGS_ROUTES = [IMPORT_PATH, SETTINGS_PATH, RULES_PATH, DERIVATION_PATH,
    SEMANTIC_CATALOG_PATH, HELP_TEXTS_PATH, VOCABULARY_TYPES_PATH, OAI_HARVEST_PATH];
var isSettingsPath = function (pathname) {
    return SETTINGS_ROUTES.some(function (path) { return pathname === path || pathname.startsWith("".concat(path, "/")); });
};
/**
 * Left-pane content helper for in-module routes (CZNA-314).
 *
 * <p>Top-level navigation now lives in the persistent {@link ActivityRail}
 * (rendered once in `index.js`), so this component no longer renders the primary
 * section switcher. It only adds the **settings sub-navigation** when the current
 * route is a settings route — keeping the settings destinations (Imports /
 * Form settings / Validation rules / MARC catalog / Derivation rules) at the top of the settings
 * pane. On every other (section) route it is a pass-through: the pane shows only
 * the section's own search/filters, which removes the former "two competing
 * menus in one pane".
 */
var NavPaneLayout = function (_a) {
    var children = _a.children;
    var pathname = useLocation().pathname;
    var inSettings = isSettingsPath(pathname);
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', height: '100%' } },
        React.createElement("div", { style: { flex: 1, overflowY: 'auto', overflowX: 'hidden' } },
            inSettings ? React.createElement(SettingsNavList, null) : null,
            children)));
};
export default NavPaneLayout;
